<template>
<div class="lookCountDetails-wrap">
    <div class="lookCountDetails">
        <div class="nav clearfix">
            <router-link to='/lookCount'>
                <img class="navBack fl" src="../../../static/images/shootShop/back.png" alt="">
            </router-link>
            <h2 class="navTitle fl">看铺次数明细</h2>
        </div>
        <div class="lookCountDetails-main">
            <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" @bottom-status-change="handleBottomChange"
                   ref="loadmore" :bottom-all-loaded="allLoaded" :auto-fill="false">
                <dl v-for="(item,index) in listArr" :class="{'changeTopBorder':index==0}">
                    <dt>
                        <h3>{{item.typeName}}</h3>
                        <p>{{item.createTime}}</p>
                    </dt>
                    <dd v-if="item.type == 5">{{item.count}}<span>次</span></dd>
                    <dd v-else class="changeColor">{{item.count}}<span>次</span></dd>
                </dl>
                <div class="noData" v-if="more">没有更多数据了...</div>
            </mt-loadmore>
        </div>
        <!-- 无数据 -->
        <div class="emptyData" v-if="emptyData==0">
            <dl>
                <dt>
                    <img src="../../../static/images/myPublish/noData.png">
                </dt>
                <p>暂无数据</p>
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'seekShop',
    data () {
        return {
            listArr: [],
            pageSize: 10, // 每次请求的数量
            pageNum: 1, // 页码 
            allLoaded: false,
            more: false,
            emptyData: ""
        }
    },
    computed:{

    },
    updated(){

    },
    methods:{
        // 获取明细列表
        postData(){
            // 接口调用
            let _this = this;
            let url = _this.changeData() + '/member/auth/selectUserOperList'
            axios(url,{
                method: 'post',
                params: {
                    cityId: sessionStorage.cityId, // 市id
                    pageSize: this.pageSize,
                    pageNum: "1"
                }
            }).then(data => {
                this.listArr = data.data.data;
                if(this.listArr == 0){
                    this.emptyData = "0";
                }else{
                    this.emptyData = "1";
                }
            }).catch(err => {
                console.log(err)
            });
        },
        //上拉加载
        loadBottom() {
            let _this = this;
            this.pageNum++;
            this.allLoaded = false;
            let url = this.changeData() + '/member/auth/selectUserOperList';
            var data = {
                cityId: sessionStorage.cityId, // 市id
                pageSize: this.pageSize, // 每页数据量【必传】
                pageNum: this.pageNum // 页码从1开始【必传】       
            }                             
            setTimeout(function () {
                axios(url,{
                    method: 'post',
                    params: data
                }).then(data => {
                    _this.listArr = _this.listArr.concat(data.data.data);
                    if(data.data.data <= 0){
                        _this.allLoaded = true;
                    }
                    _this.$refs.loadmore.onBottomLoaded();
                }).catch(err => {
                    console.log(err)
                });
            },1000)
        },
        //下拉刷新
        loadTop(){ 
            var _this = this;
            let url = this.changeData() + '/member/auth/selectUserOperList';
            var data = {
                cityId: sessionStorage.cityId, // 市id
                pageSize: this.pageSize,   // 每页数据量【必传】
                pageNum: '1',     // 页码从1开始【必传】              
            }
            setTimeout(function () {
                axios(url,{
                    method: 'post',
                    params: data
                }).then(data => {
                    _this.listArr = data.data.data;
                    _this.$refs.loadmore.onTopLoaded();
                }).catch(err => {
                    console.log(err)
                });
            },1000)
        },
        handleBottomChange(){
            var that = this;
            if(this.allLoaded == true){
                this.more = true;
                setTimeout(function () {
                    that.more = false;
                },1000)
            }
        },
    },
    mounted() {
        // 获取明细列表
        this.postData();

    }
}
</script>

<style scoped lang="scss">
/*浮动*/
.fr{
    float: right;
}
.fl{

    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

input::-webkit-input-placeholder{
    color:#fff;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#fff;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#fff;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#fff;
}
/*内容部分*/
.lookCountDetails-wrap{
    width: 7.5rem;
    margin: 0 auto;
}
.lookCountDetails{
    width: 7.5rem;
    margin: 0 auto;
    padding-top: .88rem;
}
.nav{
    width: 6.9rem;
    height: .88rem;
    background: #fff;
    margin: 0 auto;
    padding:  0 0.3rem;
    position: fixed;
    top: 0;
    z-index: 99;
    a{
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
    .navBack{
        width: 0.2rem;
        height: 0.36rem;
        margin-top: 0.26rem;
        float: left;
    }
    .navTitle{
        height: .88rem;
        width: 5.5rem;
        line-height: .88rem;
        font-size: 0.36rem;
        color: #3c3c3c;
        text-align: center;
        float: left;
        margin-left: .5rem;
    }
    p{
        position: absolute;
        right: .3rem;
        top: .22rem;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        color: #666;
        font-size: .28rem;
    }
}

.lookCountDetails-main{
    width: 6.9rem;
    padding: 0 .3rem;
    margin-top: .3rem;
    color: #363636;
    background: #fff;
    dl{
        width: 6.9rem;
        height: 1.35rem;
        border-top: 1px solid #e7e7e7;
        dt{
            float: left;
            h3{
                color: #363636;
                font-size: .28rem;
                padding-top: .3rem;
                margin-bottom: .06rem;
            }
            p{
                color: #9f9fa8;
                font-size: .24rem;
                line-height: .28rem;
            }
        }
        dd{
            float: right;
            color: #363636;
            font-size: .38rem;
            padding-top: .34rem;
            font-weight: 500;
            span{
                font-size: .28rem;
                margin-left: .05rem;
            }
        }
        .changeColor{
            color: #ff7700;
        }
    } 
    .changeTopBorder{
        border-top: none;
    }   
}

.noData{
    text-align: center;
    line-height: 1rem;
    font-size: .3rem;
}
.emptyData{
    width: 7.5rem;
    dl{
        width: 7.5rem;
        text-align: center;
        dt{
            margin-top: 2.6rem;
            margin-bottom: .3rem;
            img{
                width: 2rem;
                height: 1.3rem;
            }
        }
        p{
            font-size: .3rem;
            color: #898989;
        }
        dd{
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            span{
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                display: inline-block;
                width: 3rem;
                height: .89rem;
                background: #47abff;
                line-height: .89rem;
                color: #fff;
                font-size: .34rem;
                border-radius: 5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/lookCountDetails.vue